import { graphql } from "@/lib/gql/__generated__";

export const HotelUpdate_HotelInfoSettingsPage_Mutation = graphql(`
	mutation HotelUpdate_HotelInfoSettingsPage($input: HotelInput!) {
		hotelUpdate(input: $input) {
			userErrors
			hotel {
				id
				companyID
				hotelID
				inSale
				email
				tel
				name
				catchCopy
				customTypeRoomTitle
				facebookURL
				instagramURL
				twitterURL
				threadsURL
				lineURL
				address {
					nationality
					postalCode
					state
					pref
					city
					town
					other
				}
				geoLocation {
					lat
					lon
				}
				logoImage {
					bucket
					key
					region
					mimeType
					fileName
				}
				mainKeyVisual {
					bucket
					key
					region
					mimeType
					fileName
				}
				keyVisuals {
					bucket
					key
					region
					mimeType
					fileName
				}
				article {
					bucket
					key
					region
					mimeType
					fileName
				}
			}
		}
	}
`);
